var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-screen"},[_c('home',{directives:[{name:"show",rawName:"v-show",value:(!_vm.viewerActive),expression:"!viewerActive"}]}),_c('viewer-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewerActive),expression:"viewerActive"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }